import {
    SET_WOD_DATA,
    SET_WODS_DATA,
    SET_WOD_COUNT,
  } from '../types/types';
  
  export const setWodData = (value) => {
    return {
      type: SET_WOD_DATA,
      payload: { data: value },
    };
  };
  export const setWodCount = (value) => {
    return {
      type: SET_WOD_COUNT,
      payload: { data: value },
    };
  };
  export const setWodsData = (value) => {
    return {
      type: SET_WODS_DATA,
      payload: { data: value },
    };
  };

 export const setMemberWod=(value)=>{
  return {
    type:"SET_MEMBER_WOD",
    payload:{data:value}
  }
 } 
  export const setMemberWodLimit=(value)=>{
  return {
    type:"SET_MEMBER_WOD_LIMIT",
    payload:{data:value}
  }
 } 
  export const setMemberWodPage=(value)=>{
  return {
    type:"SET_MEMBER_WOD_PAGE",
    payload:{data:value}
  }
 } 